import { Validate } from './ValidationVariable';
import { ValidateAnyType } from './ValidationVariableAnyType';
var ValidationVariable = {
    getters: {
        Validate: Validate,
        ValidateAnyType: ValidateAnyType,
    },
};
export { ValidationVariable };
